export default __webpack_public_path__ + "static/media/complaints_page_icon.adf26401.png";